module.exports = __webpack_public_path__ + "img/business.5dcf94d6.png";